<template>
  <div class="view admin">
    <div v-if="$route.name !== 'studyList' && $route.meta.breadcrumbLevel > -1">
      <div class="main-admin-header">
        <div class="view-gabarit">
          <span class="icon-holder">
            <i class="icon-study"></i>
          </span>
          <h2 v-if="rawStudy">
            {{ rawStudy.name }}<span class="client-name">{{ $t('client') }} : {{ rawStudy.client_name }}</span>
          </h2>
        </div>
      </div>
      <div class="admin-breadcrumb">
        <div class="view-gabarit">
          <div :class="['segment', { active: rawStudy && rawStudy.need_refresh && $route.meta.breadcrumbLevel === 0 }]" @click="() => goTo('studyUploadCSV')">
            <p>1. {{ $t('studyCreation.addressFile') }}</p>
          </div>
          <div
            :class="[
              'segment',
              {
                active: rawStudy && rawStudy.need_refresh && $route.meta.breadcrumbLevel === 1,
                disabled: rawStudy && !rawStudy.need_refresh && $route.meta.breadcrumbLevel < 1,
              },
            ]"
            @click="() => goTo('studyCurrentSites')"
          >
            <p>2. {{ $t('studyCreation.currentTargetSite') }}</p>
          </div>
          <div
            :class="[
              'segment',
              {
                active: rawStudy && rawStudy.need_refresh && $route.meta.breadcrumbLevel === 2,
                disabled: rawStudy && !rawStudy.need_refresh && $route.meta.breadcrumbLevel < 2,
              },
            ]"
            @click="() => goTo('studyEditAddresses')"
          >
            <p>3. {{ $t('studyCreation.addressAdjustment1') }}</p>
          </div>
          <div
            :class="[
              'segment',
              {
                active: rawStudy && rawStudy.need_refresh && $route.meta.breadcrumbLevel === 3,
                disabled: rawStudy && !rawStudy.need_refresh && $route.meta.breadcrumbLevel < 3,
              },
            ]"
            @click="() => goTo('studyEditRegions')"
          >
            <p>4. {{ $t('studyCreation.addressAdjustment2') }}</p>
          </div>
          <div
            :class="[
              'segment',
              {
                active: rawStudy && rawStudy.need_refresh && $route.meta.breadcrumbLevel === 4,
                disabled: rawStudy && !rawStudy.need_refresh && $route.meta.breadcrumbLevel < 4,
              },
            ]"
            @click="() => goTo('studyEditDetails')"
          >
            <p>5. {{ $t('studyCreation.studyConfig') }}</p>
          </div>
          <div
            :class="[
              'segment',
              {
                active: rawStudy && rawStudy.need_refresh && $route.meta.breadcrumbLevel === 5,
                disabled: rawStudy && !rawStudy.need_refresh && $route.meta.breadcrumbLevel < 5,
              },
            ]"
            @click="() => goTo('studySummary')"
          >
            <p>6. {{ $t('studyCreation.recap') }}</p>
          </div>
        </div>
      </div>
    </div>

    <RouterView v-slot="{ Component }">
      <Transition name="fade" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>

    <Transition name="fade">
      <div v-if="isFetching && $route.name !== 'studyStatus'" class="loader-holder">
        <Loader />
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/Loader';

export default {
  components: {
    Loader,
  },

  computed: {
    ...mapGetters({
      isFetching: 'isFetching',
      rawStudy: 'rawStudy',
    }),
  },

  mounted() {
    const id = this.$route.params.studyId;
    if (!this.rawStudy || this.public_id != id) {
      this.$store.dispatch('getStudy', { id }).then(() => {
        if (this._isBeingDestroyed || this._isDestroyed) {
          this.$store.dispatch('getStudy');
        }
      });
    }
  },

  beforeUnmount() {
    this.$store.dispatch('getStudy');
  },

  methods: {
    goTo(name) {
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/animations.scss';
.admin {
  color: #3c3c3b;
  .view-container {
    // box-shadow: 0 1px 3px rgba(0, 0, 0, .1);
  }
  .view-gabarit {
    height: auto;
    max-width: 1152px;
    margin: auto;
    box-sizing: border-box;
    padding-left: 14px;
    padding-right: 14px;
  }
  fieldset {
    max-width: 370px;
    margin-left: auto;
    margin-right: auto;

    &.large {
      max-width: 740px;
    }

    label {
      font-size: 1em;
      color: #3c3c3b;
      font-weight: 600;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    // &:last-child {
    //   margin: 50px auto 60px;
    // }
  }

  .baseline {
    font-size: 1.25em;
    font-weight: 600;
    margin-top: 0;
  }
  .view-row {
    display: flex;
    padding-bottom: 26px;
    .view-description {
      flex: 1;
      b {
        font-weight: 600;
      }
    }
    .view-content {
      flex: 2;
    }
    & + .view-row {
      border-top: 1px solid #e3e3e3;
      padding-top: 48px;
    }
  }
}
.main-admin-header {
  padding-top: 62px;
  background-color: #f9f9f9;
  padding-bottom: 30px;
  .view-gabarit {
    display: flex;
    align-items: center;
  }
  .icon-holder {
    display: flex;
    width: 70px;
    height: 70px;
    justify-content: center;
    align-items: center;
    margin-right: 28px;
    overflow: hidden;
    i {
      font-size: 5em;
      color: #dbd6c7;
    }
  }
  h2 {
    margin: 0;
    font-size: 2em;
    color: #3c3c3b;
    font-weight: 600;
    display: inline-block;
    span {
      display: block;
      font-size: 16px;
      color: #9d9c9c;
      font-weight: 500;
    }
  }
  .admin-gabarit {
    max-width: 1152px;
    margin: auto;
    box-sizing: border-box;
    padding-left: 14px;
    padding-right: 14px;
  }
}
.admin-breadcrumb {
  color: #3c3c3b;
  display: flex;
  flex-direction: row;
  border-top: 1px solid rgba(#e3e3e3, 0.5);
  padding-top: 26px;
  padding-bottom: 60px;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: block;
  }

  .view-gabarit {
    flex: 1;
    display: flex;
  }

  .segment {
    flex-grow: 1;
    position: relative;
    padding-right: 12px;
    box-sizing: border-box;
    overflow: hidden;
    padding-bottom: 25px;
    cursor: pointer;

    &:before {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      background-color: colors.$red-color;
      border-radius: 50%;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    &:after {
      content: '';
      display: block;
      width: auto;
      height: 4px;
      border-radius: 4px;
      background-color: colors.$red-color;
      position: absolute;
      bottom: 3px;
      left: 14px;
      right: 4px;
    }

    &.active {
      color: colors.$red-active-color;
    }

    &.disabled {
      pointer-events: none;
      color: #d7d5d3;

      &:before {
        background-color: #d7d5d3;
      }
      &:after {
        background-color: #d7d5d3;
      }
    }

    p {
      margin: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.loader-holder {
  position: fixed;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.15);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .loader-container {
    right: 50%;
    bottom: 50%;
    margin-right: -18px;
    margin-bottom: -18px;
  }
}
</style>
